import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import { ClassifiedBucketType, Classified } from '~/models/classified/types'
import RequestBuilder from '~/builders/http/RequestBuilder'

@containerScoped()
export default class ClassifiedBucketService {
  constructor(@inject(RequestBuilder) private requestBuilder: RequestBuilder) {}

  getBucketClassifieds(bucket: ClassifiedBucketType): Promise<Classified[]> {
    return this.requestBuilder
      .request('get', `/api/classifieds/buckets/${bucket}/`)
      .validate(body => body && body.data && body.data.classifieds)
      .map(body => {
        return body.data.classifieds
      })
      .send()
  }
}
